import { Column, Typography, Stack } from '@cast/design-system';
import { BestPracticeCheckAffectedResource } from '@cast/types';

import { tableCacheKeys } from 'constants/tableCacheKeys';
import { nonNamespacedLabel } from 'features/organization/security-insights/constants';

import { NoData, NoResults, SearchableTable } from '@cast/shared-search-ui';

export type ResourceTableItem = BestPracticeCheckAffectedResource & {
  providerNamespaceId?: string;
};

export const ResourcesTable = () => {
  return (
    <SearchableTable
      cacheKey={tableCacheKeys.SECURITY.COMPLIANCE_EXCEPTIONS}
      testId="resources-table"
      sizing="m"
      maxRows={10}
      components={{
        noData: <NoData entity="resource" />,
        noResults: <NoResults entity="resource" />,
      }}
      rowKey={(resource) => JSON.stringify(resource)}
    >
      <Column
        id="name"
        header="Resource name"
        minWidth={179}
        resizable
        sortable
        cellSx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      />
      <Column id="kind" header="Kind" minWidth={100} sortable />
      <Column
        id="namespace"
        header="Namespace"
        minWidth={150}
        sortable
        renderCell={({ namespace }: ResourceTableItem) =>
          namespace ? namespace : nonNamespacedLabel
        }
      />
      <Column
        id="clusterName"
        header="Cluster"
        minWidth={160}
        sortable
        renderCell={({
          clusterName,
          providerNamespaceId,
        }: ResourceTableItem) => (
          <Stack>
            <Typography variant="P10R">{clusterName}</Typography>
            {providerNamespaceId && (
              <Typography variant="P10R" color="textSecondary" mt={-4}>
                {providerNamespaceId}
              </Typography>
            )}
          </Stack>
        )}
      />
    </SearchableTable>
  );
};
